import React, { Component } from 'react';

export default class Simulate extends Component {
  constructor(props) {
    super(props);
    this.addPiece = this.addPiece.bind(this)
    this.montant = this.montant.bind(this)
    var pieces = []
    props.pieces.map((piece)=>{
      pieces.push({
        id: piece.id,
        titre: piece.titre,
        text: piece.text,
        quantite: 0
      })
    })
    this.state = {
      pieces: pieces,
      typedebien: props.typedebiens[0].id,
      typededemande: props.typededemandes[0].id
    };

  }
  addPiece(e){
    let val = parseInt(e.target.value)
    let index = e.target.dataset.piece
    let pieces = this.state.pieces
    pieces[index].quantite= val
    this.setState({
      pieces: pieces
    })
  }
  montant(){
    let total = this.props.pricing.find((item)=> item.typededemande_id==this.state.typededemande && item.typedebien_id==this.state.typedebien).price
    this.state.pieces.map((piece,index)=>{
      total += this.props.pricingPiece.find((item)=> item.typedepiece_id==piece.id &&item.typededemande_id==this.state.typededemande && item.typedebien_id==this.state.typedebien).price * piece.quantite
    })
    return total

  }
  render() {
    return (
      <div className='row'>
          <div className="col s6">
            <h2 className="center">Type de bien </h2>
            <div className="container">
            <div className="row">
              <div className="col s5">Pour un/une</div>
            <div className="col s5">
              <select name=""
              className="browser-default"
              value={this.state.typedebien}
              onChange={(e)=> this.setState({typedebien: e.target.value})}
              id="">
              {this.props.typedebiens.map((type)=>(
                  <option key={type.id} value={type.id}>{type.titre}</option>
                ))}
              </select>
            </div>
            <div className="col s2">un</div>
              <select name=""
              className="browser-default"
              value={this.state.typededemande}
              onChange={(e)=> this.setState({typededemande: e.target.value})}
              id="">
              {this.props.typededemandes.map((type)=>(
                  <option key={type.id} value={type.id}>{type.titre}</option>
                ))}
              </select>

            </div>
            <div className="row">
              <p>vous coûtera {this.montant()} € (à diviser entre les parties)</p>
            </div>

            </div>
          </div>
        {this.state.pieces.map((piece,index)=>(
            <div className="" key={index}>
              <div className="col s6">
                <div className="card white">
                  <div className="row">
                    <div className="col s6">
                      <div className={"side-image-small side-image-"+piece.titre}></div>
                    </div>
                    <div className="col s3">
                      <h2>{piece.titre}</h2>
                      <p>{piece.text}</p>
                    </div>
                    <div className="col s3">
                      <select data-piece={index} value={piece.quantite} onChange={this.addPiece} name="" className="browser-default" id="">
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  }
}
